import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const CustomCompanyEmailTemplateSchema = withDefaults({
  type: 'custom-company-email-template',
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'subject',
    },
    {
      kind: 'attribute',
      name: 'editorJsData',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: 'customCompanyEmailTemplates',
      },
    },
    {
      kind: 'belongsTo',
      name: 'emailTemplate',
      type: 'email-template',
      options: {
        async: false,
        inverse: 'customCompanyEmailTemplates',
      },
    },
  ],
});

export default CustomCompanyEmailTemplateSchema;
